import request from './request';

const asset = {
	async getLocationAssetsByLocationId(query) {
		const response = await request.get('/app/assets/id', query);
		return response;
	},
	async getAllBaseMap(query) {
		const response = await request.get('/app/assets/all-base-map');
		return response;
	}
};

export default asset;